<template>
  <div class="firmwareNew">
    <div class="section">
      <div class="search">
        <!-- <div class="list-header">
          <div class="title">{{$t('firmware.Firmware_Lists')}}</div>
        </div> -->
        <!-- <div class="search"> -->
        <button
          type="button"
          class="button-upload"
          @click="addFirmware()"
        >
          {{ $t('firmware.Upload_firmware') }}
          <i class="iconfont icon-biaogegongneng_shangchuan"></i>
        </button>
      </div>
      <el-table
        class="tablemain tableloding"
        v-loading="isLoading"
        element-loading-spinner="el-icon-loading"
        height="100%"
        stripe
        border
        :data="dataCode"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        :empty-text="$t('account.nodata')"
      >
        <el-table-column
          width="130px"
          type="index"
          :label="$t('recharge.serial_number')"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="firmwareName"
          :label="this.$t('firmware.Firmware_Name')"
          min-width="150px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          :label="this.$t('firmware.Firmware_desrc')"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.versionNote || '--'">{{ scope.row.versionNote || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('browse.desc')"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.remark || '--'">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fileSize"
          :label="this.$t('firmware.Size')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :title="scope.row.fileSize || '0'">{{ formatSize2(scope.row.fileSize)  || '0' }}</span>
          </template>

        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="this.$t('firmware.Upload_Time')"
          min-width="150px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          :label="this.$t('firmware.Operation')"
          fixed="right"
          width="100px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">

            <el-button
              type="text"
              class="operation"
              :title="$t('firmware.deleteFirmware')"
              @click="editFirmware(scope.row)"
            >
              <i class="iconfont icon-edit1"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('firmware.deleteFirmware')"
              @click="deleteFirmware(scope.row)"
            >
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
                <div style="line-height: 32px">{{$t('account.nodata')}}</div></div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span
          class=""
          style="margin-left:16px;"
        ></span>
        <!-- v-show="paginationControl" -->
        <el-pagination
          class="pagination"
          background
          @size-change="getData(true)"
          @current-change="() => getData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>

    <!-- 删除固件对话框 -->
    <!-- v-if="dialogVisible" -->
    <firmware-dialog
      :title="$t('firmware.del_firmware')"
      :visible.sync="dialogVisible"
      :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }"
      width="30vw"
      noFooter
    >
      <div
        class="content_tishi"
        slot="content"
      >
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span
            class="contentdelete"
            style="width:100%;text-align:left;"
          >{{ $t('firmware.delete_firmware') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div
          class="deletfotter"
          style="text-align:right;margin-top:28px;"
        >
          <button
            type="button"
            class="btn btn-dark"
            @click="configdelete()"
            style="margin-right:10px;"
          >{{
            $t('firmware.confirm') }}</button>
          <button
            type="button"
            class="btn btn-light"
            @click="dialogVisible = false"
          >{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </firmware-dialog>
    <!-- 删除固件结果提示(成功) -->
    <!-- v-if="firmwareDelSucVisible" -->
    <firmware-dialog
      :title="$t('datalogger.delResults')"
      :visible.sync="firmwareDelSucVisible"
      :class="{ 'showDialog': firmwareDelSucVisible, 'hideDialog': !firmwareDelSucVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.deleteSuc') }}</span>
          <!-- <span class="showresulttext">{{FirmwareTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="firmwareDelSucVisible = false;"
            >{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>
    <!-- 删除固件结果提示(失败) -->
    <!-- v-if="firmwareDelFailVisible" -->
    <firmware-dialog
      :title="$t('datalogger.delResults')"
      :visible.sync="firmwareDelFailVisible"
      :class="{ 'showDialog': firmwareDelFailVisible, 'hideDialog': !firmwareDelFailVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ FirmwareTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="firmwareDelFailVisible = false;"
            >{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>

    <!-- 增加固件对话框 -->
    <!-- v-if="dialogAdd" -->

    <!-- 增加固件对话框 -->
    <firmware-dialog
      :title="$t('firmware.Upload_firmware')"
      :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }"
      :visible.sync="dialogAdd"
      width="40vw"
      noFooter
    >
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item
            :label="$t('firmware.Firmware_description')"
            size="small"
          >
            <el-input
              v-model="note"
              :placeholder="$t('firmware.enter_content')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('browse.desc')"
            size="small"
          >
            <el-input
              v-model="remark"
              :placeholder="$t('firmware.enter_content')"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <!-- <button
                type="button"
                class="upload-buttonEquipment"
                @click.prevent="$refs.fileUploader.click()"
              >
                <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept=".hex,.bin,.s19"
                @change="uploadfile($event)"
              />
              <div
                class="uploadfileList-box"
                v-for="(item,index) in uploadfileList"
                :key="index"
              >{{item}}</div> -->
              <!-- el-upload 多个上传 -->
              <el-upload
                :limit="limitNumber"
                :multiple="true"
                class="upload-Firmware"
                ref="uploadFirmware"
                :on-remove="handleRemove"
                :file-list="fileList"
                :on-exceed="onExceed"
                :auto-upload="false"
                accept=".hex,.bin,.s19"
                :on-change="handleChange"
                action="#"
                :show-file-list="false"
              >
                <!-- :before-upload="beforeUpload" -->
                <!-- :http-request="httpRequest" -->
                <div class="uploadFirmwareBtn">
                  <button
                    slot="trigger"
                    type="button"
                    class="upload-buttonEquipment"
                  >
                    <i class="iconfont icon-shangchuan1"></i>
                  </button>
                  <!-- <el-button
                    style=""
                    size="small"
                    type="success"
                    @click.stop="submitUpload"
                  >上传到服务器</el-button> -->
                </div>
                <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
                <!-- 2. 自定义文件列表（带序号） -->

              </el-upload>

            </div>
            <ul
              class="custom-file-list"
              v-if="fileList.length > 0"
            >
              <li
                v-for="(file, index) in fileList"
                :key="file.uid"
                class="file-item"
              >
                <!-- 序号 -->
                <span class="file-index">{{ index + 1 }}、</span>

                <!-- 文件信息 -->
                <div class="file-info">
                  <i class="el-icon-document"></i>
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatSize(file.size) }}</span>
                </div>

                <!-- 删除按钮 -->
                <i
                  class="el-icon-close file-delete"
                  @click.stop="handleRemoveItem(file, fileList)"
                ></i>
              </li>
            </ul>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-dark"
            @click="submitUpload"
          >{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </firmware-dialog>

    <!-- 增加固件结果提示(成功) -->
    <!-- v-if="addFirmwareSucVisible" -->
    <firmware-dialog
      :title="$t('upgradeManagement.upload_result')"
      :visible.sync="addFirmwareSucVisible"
      :class="{ 'showDialog': addFirmwareSucVisible, 'hideDialog': !addFirmwareSucVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
          <span class="showresulttext">{{ FirmwareTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="addFirmwareSucVisible = false;"
            >{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>
    <!-- 增加固件结果提示(失败) -->
    <!-- v-if="addFirmwareFailVisible" -->
    <firmware-dialog
      :title="$t('upgradeManagement.upload_result')"
      :visible.sync="addFirmwareFailVisible"
      :class="{ 'showDialog': addFirmwareFailVisible, 'hideDialog': !addFirmwareFailVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">

          <span v-if="successDetails && successDetails.length" style="width: 100%;display: flex;flex-flow: row nowrap;align-items: center;justify-content: flex-start;gap: 12px;">
            <span
              class="showbase showsuccess"
              style="width: 50px;height: 50px;background-size: 35px 35px;"
            ></span>
            <span style="font-weight: bold;font-size: 18px;margin-top: 20px;margin-bottom: 30px;color: rgba(255, 255, 255, 1);margin: 0;">{{ $t('createPlant.uploadSuccess') }}:</span>
          </span>
          <span
            class="showresulttext"
            style="width: 100%;font-weight: normal;font-size: 16px;margin-top: 8px;"
          >

            <span
              style="display: block;"
              v-for=" (item,index) in successDetails"
              :key="index"
            >{{ item.fileName }} {{ $t('createPlant.uploadSuccess') }}</span>

          </span>

          <span style="width: 100%;display: flex;flex-flow: row nowrap;align-items: center;justify-content: flex-start;gap: 12px;">
            <span
              class="showbase showfail"
              style="width: 50px;height: 50px;background-size: 35px 35px;"
            ></span>
            <span style="font-weight: bold;font-size: 18px;margin-top: 20px;margin-bottom: 30px;color: rgba(255, 255, 255, 1);margin: 0;">{{ $t('firmware.Firmware_upload_failTip') }}:</span>
          </span>

          <span
            class="showresulttext"
            style="width: 100%;font-weight: normal;font-size: 16px;margin-top: 8px;"
          >
            <span
              style="display: block;"
              v-for=" (item,index) in failureDetails"
              :key="index"
            >{{ item.fileName }} {{ item.errorMessage }}</span>

          </span>
          <!-- 确定 -->
          <div class="showoperate">
            <button
              type="button"
              class="btn btn-dark"
              @click="addFirmwareFailVisible = false;"
            >{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>

    <!-- 编辑固件对话框   -->
    <firmware-dialog
      :title="$t('upgradeManagement.edit_firmware')"
      :class="{ 'showDialog': dialogEdit, 'hideDialog': !dialogEdit }"
      :visible.sync="dialogEdit"
      width="40vw"
      noFooter
    >
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item
            :label="$t('firmware.Firmware_description')"
            size="small"
          >
            <el-input
              v-model="note"
              :placeholder="$t('firmware.enter_content')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('browse.desc')"
            size="small"
          >
            <el-input
              v-model="remark"
              :placeholder="$t('firmware.enter_content')"
            ></el-input>
          </el-form-item>

        </el-form>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-dark"
            @click="warningTipButton"
          >{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </firmware-dialog>

  </div>
</template>
<script>
import firmwareDialog from "@/components/dialognew";

let currentMessageInstance = null;
export default {
  components: {
    firmwareDialog,
  },
  data() {
    return {
      failureDetails: [],
      successDetails: [],
      limitNumber: 10,
      limitM: 8,
      uploadfileList: [],
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],

      uploadfileList: [],
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo: sessionStorage.getItem("disPermissionsLogo")
        ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
        : false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")
        ? JSON.parse(sessionStorage.getItem("buttonArr"))
        : [],
      emptyText: false,
      paginationControl: false,
      isLoading: false,
      file: null, //保存上传文件流的容器
      form: {
        name: "",
      },
      note: "",
      remark: "", //备注
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100,
      },
      alarmtype: [
        {
          label: "Warning",
          value: "warning",
        },
        {
          label: "Error",
          value: "error",
        },
        {
          label: "Fault",
          value: "fault",
        },
      ],
      // 固件列表
      dataCode: [
        // { "firmware": "mcu+4g_3_5_4_2.bin-ota.bin",}
      ],
      params: "",
      // 删除固件
      dialogVisible: false,
      // 增加固件
      dialogAdd: false,
      // 编辑固件
      dialogEdit: false,
      // 增加固件成功
      addFirmwareSucVisible: false,
      // 增加固件失败
      addFirmwareFailVisible: false,
      // 增加固件成功
      firmwareDelSucVisible: false,
      // 增加固件失败
      firmwareDelFailVisible: false,
      // 操作固件返回提示
      FirmwareTipMsg: "",
      FirmwareTipMsgError: "",
    };
  },
  watch: {
    dialogAdd(val) {
      this.fileList = [];
      this.uploadfileList = [];

      this.$nextTick(() => {
        this.$refs.uploadFirmware && this.$refs.uploadFirmware.clearFiles();
      });
    },
    dialogEdit(val) {
      if (!val) {
        this.note = "";
        this.remark = "";
      }
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    //点击确定时友情提示让其上传固件文件
    warningTipButton() {
      let action =
        "/upg/api/auth/web/device/firmware/description/" + this.params.id;
      // let action = "/upg/api/auth/web/device/firmware/" + this.params.id;
      let params = {
        id: this.params.id,
        remark: this.remark,
        versionNote: this.note,
      };
      this.$request.put(action, params).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.$t("upgradeManagement.eidt_success"));
          this.dialogEdit = false;
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 格式化文件大小
    formatSize(size) {
      if (!size) return "";
      if (size < 1024) return size + "B";
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + "KB";
      return (size / (1024 * 1024)).toFixed(2) + "MB";
    },
    // 格式化文件大小
    formatSize2(size) {
      if (!size) return "";
      return (size / 1024).toFixed(2);
    },
    /**
     * 3. 移除文件
     */
    handleRemove(file, fileList) {
      // 同步列表
      // console.log();

      this.fileList = fileList;
      console.log("移除后列表1:", fileList);
    },
    handleRemoveItem(file, fileList) {
      // 同步列表
      console.log("移除文件:", file, fileList);
      this.fileList = fileList.filter((f) => f.uid !== file.uid);
      // this.fileList = fileList;
      console.log("移除后列表:", fileList);
    },
    /**
     * 4. 超出数量限制
     */
    onExceed(files, fileList) {
      console.log("超出数量限制:", files, fileList);
      this.$message.warning(
        `${this.$t("firmware.Firmware_limit1")}${this.limitNumber}${this.$t(
          "firmware.Firmware_limit2"
        )}${this.$t("firmware.Firmware_limit3")}`
      );
    },
    /**
     * 2. 手动触发上传
     * 核心逻辑：组装 FormData，一次性发送所有文件
     */
    submitUpload() {
      // 检查列表是否为空
      if (this.fileList.length === 0) {
        this.$message.warning(this.$t("upgradeManagement.please_upgrade"));
        return;
      }

      // 创建 FormData
      const formData = new FormData();
      console.log("this.fileList", this.fileList);
      // 【关键修复】遍历列表，添加所有文件
      this.fileList.forEach((item, index) => {
        // 必须使用 item.file.raw 才能获取原生 File 对象
        console.log("item", item);
        if (item && item.raw && item.name) {
          const flag = index + 1;
          // formData.append(`name${flag}`, item.name);
          // formData.append(`file${flag}`, item.raw);
          formData.append(`name`, item.name);
          formData.append(`file`, item.raw);
        }
      });

      // 【关键修复】添加其他参数，使用 || '' 防止 "null" 字符串
      formData.append("versionNote", this.note || "");
      formData.append("remark", this.remark || "");

      // 调试：打印 FormData 内容
      console.log("--- 准备发送的 FormData ---");
      console.log(Array.from(formData));

      // 发送请求 (只发送一次)
      this.$request
        .uploadfilesAxios(formData)
        .then((res) => {
          if (res.code === 0) {
            if (res.data.failureCount == 0) {
              this.$message.success(this.$t("createPlant.uploadSuccess"));
              // 上传成功后处理
              // this.uploadfileList.push(...this.fileList.map((f) => f.name));
              this.getData(); // 刷新列表

              // 清空上传组件
              this.uploadfileList = [];
              this.fileList = [];
              this.$refs.uploadFirmware.clearFiles();
              this.addFirmwareSucVisible = true;
              this.dialogAdd = false;
            } else {
              this.failureDetails = res.data.failureDetails;
              this.successDetails = res.data.successDetails;
              // this.FirmwareTipMsgError = ""
              // res.data.failureDetails && res.data.failureDetails.map((item=>{
              //   this.FirmwareTipMsgError += `${item.fileName} ${item.errorMessage}`
              // }))||[]
              this.getData(); // 刷新列表

              // 清空上传组件
              this.uploadfileList = [];
              this.fileList = [];
              this.$refs.uploadFirmware.clearFiles();
              this.dialogAdd = false;
              this.addFirmwareFailVisible = true;
              // this.$message.error(this.$t("firmware.Firmware_upload_fail"));
            }
          } else if (res.code === 6) {
            this.$message.error(this.$t("firmware.error1"));
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(this.$t("firmware.Firmware_upload_fail"));
          console.error(err);
        });
    },
    handleChange(file, fileList) {
      console.log("handleChange", file, fileList);
      if (!file) {
        return false;
      }
      // if (fileList.length > this.limitNumber) {
      //   fileList = fileList.slice(0, this.limitNumber);
      //   // 注意：这里不需要 return，因为我们要继续处理剩下的校验逻辑
      //   this.$message.warning(
      //     `${this.$t("firmware.Firmware_limit1")}${this.limitNumber}${this.$t(
      //       "firmware.Firmware_limit2"
      //     )}${this.$t("firmware.Firmware_limit3")}`
      //   );
      // }
      // 同步列表
      this.fileList = fileList;

      if (!file || file.status !== "ready") return;

      const showError = (msg) => {
        // 如果当前有正在显示的提示，先把它关掉
        if (currentMessageInstance) {
          currentMessageInstance.close();
        }
        // 显示新提示，并保存实例
        currentMessageInstance = this.$message.error(msg);
      };

      const allowedTypes = ["hex", "bin", "s19"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const isAllowedType = allowedTypes.includes(fileExtension);
      const isLt8M = file.size <= this.limitM * 1024 * 1024; // 8MB
      let needRemove = false;
      let errorMsg = "";
      // 4. 校验逻辑（只标记需要删除，不立即修改数组引用）
      if (!isAllowedType) {
        // this.$message.error(); file.name
        errorMsg = `${this.$t("firmware.Firmware_limit_format")}`;
        needRemove = true;
      } else if (!isLt8M) {
        errorMsg = `${this.$t("firmware.Firmware_limitM")}${this.limitM}M`;

        needRemove = true;
      }

      // 5. 执行删除操作（核心修改点）
      if (needRemove) {
        //  this.$message.error(errorMsg);
        showError(errorMsg);
        // 找到该文件在列表中的索引
        const index = fileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          // 先确保 this.fileList 和 fileList 是同一个引用（如果还没同步的话）
          // 这一步是为了防止 this.fileList 还是旧数据
          if (this.fileList.length !== fileList.length) {
            this.fileList = fileList;
          }

          // 使用 splice 直接修改数组，而不是替换整个数组
          // 这样 Vue 的响应式系统能更精准地捕捉到变化
          this.fileList.splice(index, 1);

          // 【关键】强制同步 el-upload 组件内部的文件列表
          // 否则组件内部状态不一致，界面可能不更新
          this.$nextTick(() => {
            if (this.$refs.uploadFirmware) {
              this.$refs.uploadFirmware.uploadFiles = this.fileList;
            }
          });
        }
      } else {
        // 如果文件校验通过，再同步列表（处理数量截断后的同步）
        this.fileList = fileList;
      }
      // if (!isAllowedType) {
      //   this.$message.error(`${this.$t("firmware.Firmware_limit_format")}`);
      //   // `文件 "${file.name}" 格式不支持，仅限 .hex, .bin, .s19`
      //   this.fileList = fileList.filter((f) => f.uid !== file.uid);
      // } else if (!isLt8M) {
      //   this.$message.error(
      //     `${this.$t("firmware.Firmware_limitM")}${this.limitM}M`
      //   );
      //   // 移除不合规的文件
      //   console.log("有文件超过8M",file,fileList);

      //   this.fileList = fileList.filter((f) => f.uid !== file.uid);
      // } else if (this.fileList.length > this.limitNumber) {
      // }
      // console.log("this.fileList 最终", this.fileList,fileList);
    },
    /**
     * 1. 文件校验钩子
     * 在文件加入列表前进行格式和大小的校验
     */
    beforeUpload(file) {
      const allowedTypes = ["hex", "bin", "s19"];
      console.log("beforeUpload file", file);

      if (!file) {
        return false;
      }
      // 获取文件后缀名
      const fileExtension = file.name.split(".").pop().toLowerCase();
      console.log("fileExtension", fileExtension);

      // 校验文件类型
      const isAllowedType = allowedTypes.includes(fileExtension);
      // 校验文件大小（例如限制 8MB）
      const isLt8M = file.size <= 8 * 1024 * 1024;

      if (!isAllowedType) {
        this.$message.error("只能上传 .hex, .bin, .s19 格式的文件!");
        return false;
      }
      if (!isLt8M) {
        this.$message.error("单个文件大小不能超过 8MB!");
        return false;
      }
      return true;
    },

    /**
     * 2. 自定义上传逻辑
     * 由于使用了 :auto-upload="false"，需要拦截默认请求
     * 这里可以使用 axios 或原生 fetch 发送请求
     */
    httpRequest(uploadFile) {
      // uploadFile 包含了 file, name 等信息
      console.log("uploadFile", uploadFile);
      console.log("uploadFile.file", uploadFile.file);
      const formData = new FormData();
      this.fileList.forEach((item) => {
        // item.file 是 ElementUI 包装的对象，item.file.raw 才是真正的 File 对象
        if (item.file && item.file.raw) {
          formData.append("file", item.file.raw);
        }
      });

      // formData.append('file', uploadFile.file);
      formData.append("versionNote", this.note || "");
      formData.append("remark", this.remark || "");
      // console.log("formData:", formData);
      console.log("FormData 内容:", Array.from(formData));
      this.$request
        .uploadfileAxios(formData)
        // .uploadfileAxios(formData, this.desc, this.remark)
        .then((res) => {
          if (res.code === 0) {
            uploadFile.onSuccess(0); // 通知组件上传成功
            this.$message.success(this.$t("createPlant.uploadSuccess"));
            this.fileList = [];
            this.$refs.uploadFirmware.clearFiles();
            this.getData();
            // this.uploadfileList.push(file.name);
            // this.getData();
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else if (res.code === 6) {
            uploadFile.onError(6); // 通知组件上传失败
            this.$message.error(this.$t("firmware.error1"));
            // 关闭二次弹窗
            // this.dialogAdd = false;
          } else {
            uploadFile.onError(-1); // 通知组件上传失败
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // 关闭二次弹窗
            // this.dialogAdd = false;
          }
          setTimeout(() => {
            this.getData();
          }, 500);
        })
        .catch((err) => {
          uploadFile.onError(-1); // 通知组件上传失败
        });

      // 为了演示，这里模拟一个成功的响应
      setTimeout(() => {
        uploadFile.onSuccess({ code: 200, message: "上传成功" });
      }, 1000);
    },

    submitUpload2() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先选择文件");
        return;
      }

      // 注意：二进制流上传通常一次只传一个文件最稳妥
      // 如果你要传多个文件，通常需要对 fileList 进行循环，发起多次请求
      // 这里演示上传列表中的第一个文件，或者你可以把它放在循环里

      const fileItem = this.fileList[0]; // 获取第一个文件对象
      const rawFile = fileItem.file.raw; // 获取原生 File 对象

      // 【关键】准备元数据（通过 URL 参数传递）
      const params = {
        versionNote: this.note || "",
        remark: this.remark || "",
        fileName: rawFile.name, // 也可以把文件名传过去，防止后端解析不到
      };

      console.log("准备上传文件:", rawFile.name);
      console.log("附带参数:", params);

      // 发送请求
      // 注意：这里不再传 formData，而是直接传 rawFile
      this.$request
        .uploadfileAxios(rawFile, params)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success("上传成功");
            this.fileList = [];
            this.$refs.uploadFirmware.clearFiles();
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error("上传失败");
        });
    },

    getData(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
      this.$request
        .getUPG(
          "/upg/api/auth/web/device/firmware/adaptive",
          // "/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware",
          {
            page: this.pagination.currentPage - 1,
            pagesize: this.pagination.pagesize,
          }
        )
        .then((res) => {
          if (res.code == 0) {
            res.data.items.forEach((item) => {
              item.size = (item.size / 1024).toFixed(2);
            });
            this.dataCode = res.data.items;
            this.pagination.total = res.data.total;
            if (this.pagination.total > this.pagination.pagesize) {
              this.paginationControl = true;
            }
          } else {
            this.emptyText = true;
            this.dataCode = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        });
    },
    //删除固件进入界面按钮
    deleteFirmware(info) {
      if (
        this.disPermissionsLogo &&
        !this.btnList.includes("delete_firmware")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.dialogVisible = true;
      this.params = info;
    },
    //编辑固件进入界面按钮
    editFirmware(info) {
      if (
        this.disPermissionsLogo &&
        !this.btnList.includes("upload_firmware")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.dialogEdit = true;
      this.params = {
        ...info,
        versionNote: info.versionNote,
        note: info.versionNote,
      };
      console.log("info", info);
      /**
       * {
            "desc": "11",
            "firmware": "202604092020427002D578B06-rrr.hex",
            "gts": "2026-04-09 20:20:42",
            "id": "69d7999a4b38d51b74beca25",
            "md5": "E10ADC3949BA59ABBE56E057F20F883E",
            "size": "0.01",
            "uid": 57791
        }
       */
      this.note = info.versionNote;
      this.remark = info.remark;
    },
    //删除固件
    configdelete() {
      this.$request
        .delete(
          // `/upg/api/auth/web/shineDess/collector/upgrade/delFiremware/${this.params.id}`
          `/upg/api/auth/web/device/firmware/${this.params.id}`
        )
        .then((res) => {
          if (res.code == 0) {
            // this.$message.success(this.$t("firmware.deleteSuc"));
            this.firmwareDelSucVisible = true;
            setTimeout(() => {
              this.getData();
            }, 500);
            this.dialogVisible = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            // this.FirmwareTipMsg = this.$t(`errCode.${res.code}`);
            this.FirmwareTipMsg = res.message;
            this.firmwareDelFailVisible = true;
          }
        });
    },
    //增加固件进入界面按钮
    addFirmware() {
      if (
        this.disPermissionsLogo &&
        !this.btnList.includes("upload_firmware")
      ) {
        return this.$message.warning(this.$t("account.No_permission_prompt"));
      }
      this.uploadfileList = [];
      this.dialogAdd = true;
      this.failureDetails = [];
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        // 清空上传组件
        this.fileList = [];
        this.$refs.uploadFirmware.clearFiles();
        // this.$refs.fileUploader.value = null;
        this.note = "";
        this.remark = "";
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // this.$refs.upload.clearFiles()
      let file = event.target.files[0];
      console.log(event, file);
      if (!file) {
        return;
      }
      // if(!this.desc){
      //   this.$message.warning(this.$t('firmware.enter_content'));
      //   return;
      // }
      // if(!this.remark){
      //   this.$message.warning(this.$t('firmware.enter_content'));
      //   return;
      // }

      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("createPlant.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];

      console.log("suffix", suffix);
      if (!suffix) {
        console.log("!suffix");

        this.$message.error(this.$t("firmware.error1"));
        return;
      }

      const allowed = ["bin", "hex", "s19"];
      if (!allowed.includes(suffix.toLowerCase())) {
        console.log("fomart error");
        this.$message.error(this.$t("firmware.error1"));
        return;
      }

      // console.log(suffix !== "bin" && suffix !== "hex" && suffix !== "S19",'suffix');
      // if (suffix !== "bin" && suffix !== "hex" && suffix !== "S19") {
      //   this.$message.error(this.$t("firmware.error1"));
      //   return;
      // }
      this.$request
        .uploadfileAxios(file, this.note, this.remark)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(this.$t("createPlant.uploadSuccess"));
            this.uploadfileList.push(file.name);
            // this.getData();
            // 关闭二次弹窗
            // this.dialogAdd = false;
          } else if (res.code === 6) {
            this.$message.error(this.$t("firmware.error1"));
            // 关闭二次弹窗
            // this.dialogAdd = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // 关闭二次弹窗
            // this.dialogAdd = false;
          }
          setTimeout(() => {
            this.getData();
          }, 500);
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.upload-Firmware {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .uploadFirmwareBtn {
    flex-flow: row;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }

  /* 隐藏原生列表（如果没加 show-file-list="false" 则必须加这个） */
  &::v-deep .el-upload-list {
    display: none;
  }
}
/* 自定义列表样式 */
.custom-file-list {
  list-style: none;
  padding: 0;
  margin-top: 15px;
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
  // background: #f5f7fa;
  // display: flex;
  // flex-direction: column;
  // gap: 16px;
  .file-item {
    display: flex;
    align-items: center;
    padding: 0px 0px;
    // border-bottom: 1px solid #dcdfe6;
    transition: all 0.3s;
  }

  // .file-item:last-child {
  //   border-bottom: none;
  // }

  // .file-item:hover {
  //   background: #fff;
  // }

  /* 序号样式 */
  .file-index {
    display: inline-block;
    // width: 24px;
    // height: 24px;
    // line-height: 24px;
    text-align: center;
    // background: #409eff;
    color: #fff;
    // border-radius: 50%;
    font-size: 12px;
    // margin-right: 15px;
    flex-shrink: 0;
  }

  .file-info {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .file-info i {
    font-size: 20px;
    color: #909399;
    margin-right: 10px;
  }

  .file-name {
    font-size: 14px;
    color: #606266;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
  }

  .file-size {
    font-size: 12px;
    color: #909399;
    flex-shrink: 0;
  }

  .file-delete {
    cursor: pointer;
    font-size: 18px;
    color: #909399;
    margin-left: 10px;
    transition: color 0.3s;
  }

  .file-delete:hover {
    color: #f56c6c;
  }
}

.firmwareNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;

  // margin: 24px 24px 50px 24px;
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-end;

    // display: flex;
    // justify-content: space-between;
    .button-upload {
      display: flex;
      //多语言状态下文字间隔优化
      line-height: 16px;
      justify-content: space-between;
      align-items: center;
      width: 114px;
      height: 48px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 14px;
      border-radius: 0px;
      border: none;
      cursor: pointer;

      .ico-download {
        width: 16px;
        height: 16px;
        background: url(../../assets/img/general/Icon_Download.png) no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 10px;
      }
    }
  }

  .upload-button {
    margin-left: 80px;
    padding: 6px 16px;
  }

  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  // .contentdelete {
  //   font-size: 18px;
  //   color: rgba(255, 62, 62, 1);
  //   font-weight: bold;
  // }
  // .disabledescr {
  //   color: rgba(255, 255, 255, 1);
  //   font-size: 14px;
  // }
  .deletfotter {
    margin-top: 50px;

    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }

    .button-solid {
      width: 100px;
      height: 40px;
    }
  }

  .upload-input {
    display: none;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
.firmware {
  .search {
    .el-select,
    .el-input {
      width: 165px;

      .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 20px;
      }
    }
  }

  .upload-button {
    width: 100%;
  }
}
</style>